module.exports = __webpack_public_path__ + "img/no_coupon_3.ed024f78.png";